import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CognitoUser } from "amazon-cognito-identity-js";
import { userPool } from "../../services/cognitoService";
import { debug } from "../../utils/debugLogger";
import AuthLayout, {
  AuthError,
  authButtonClassName,
  authInputClassName,
  authLabelClassName,
  authLinkButtonClassName,
} from "./AuthLayout";

const VerifyEmail: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [verificationCode, setVerificationCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const email = location.state?.email;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const userData = {
      Username: email,
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.confirmRegistration(verificationCode, true, (err, result) => {
      setLoading(false);

      if (err) {
        setError(err.message || "An error occurred during verification");
        return;
      }

      debug.log("Verification successful");
      navigate("/");
    });
  };

  const handleResendCode = () => {
    if (!email) {
      setError("Email is required to resend code");
      return;
    }

    const userData = {
      Username: email,
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.resendConfirmationCode((err, result) => {
      if (err) {
        setError(err.message || "Error resending code");
        return;
      }
      alert("A new verification code has been sent to your email");
    });
  };

  if (!email) {
    return (
      <AuthLayout
        title="Error: Email not found"
        subtitle="Please return to the signup page and try again."
      />
    );
  }

  return (
    <AuthLayout
      title="Verify your email"
      subtitle={`We've sent a verification code to ${email}`}
    >
      <form className="w-full space-y-5" onSubmit={handleSubmit}>
        {error && <AuthError message={error} />}

        <div>
          <label htmlFor="verification-code" className={authLabelClassName}>
            Verification code
          </label>
          <input
            id="verification-code"
            name="verification-code"
            type="text"
            required
            placeholder="Enter verification code"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            className={authInputClassName}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className={authButtonClassName}
        >
          {loading ? "Verifying..." : "Verify email"}
        </button>

        <div className="text-center">
          <button
            type="button"
            onClick={handleResendCode}
            className={authLinkButtonClassName}
          >
            Resend verification code
          </button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default VerifyEmail;
